import { useThemeStore } from "@/stores/theme.store.ts";
import { AppContext, AppContextProps } from "@/themes/app-context.ts";
import { getDarkModeColor } from "@/themes/dark-mode.ts";
import { applyThemeConfig } from "@/themes/apply-theme.ts";
import { getAppTheme } from "@/themes/theme.types.ts";
import { useSystemDarkMode } from "@/themes/use-system-dark-mode.ts";
import { ReactNode, useEffect, useMemo } from "react";

export interface AppProviderProps {
  children: ReactNode;
  isStorybook?: boolean;
}

export function AppProvider({ children, isStorybook }: AppProviderProps) {
  const { theme, setTheme, colorMode } = useThemeStore();
  const systemDarkMode = useSystemDarkMode();
  const darkMode = colorMode === "dark" || (colorMode === "system" && systemDarkMode);

  const context: AppContextProps = useMemo(() => {
    let appThemeBundle = getAppTheme(theme);

    if (appThemeBundle == undefined) {
      setTheme("default");
      appThemeBundle = getAppTheme(null);
    }
    return {
      theme: appThemeBundle,
    };
  }, [theme]);

  useEffect(() => {
    applyThemeConfig(context.theme.appThemeConfig, darkMode, getDarkModeColor);
    if (!isStorybook) {
      document.body.classList.remove(...document.body.classList);
      document.body.className = context.theme.appTheme.body.base;

      document.body.style.background =
        "linear-gradient(160deg, hsl(var(--var-color-background-gradient-from)) 0%, hsl(var(--var-color-background-gradient-to)) 78.17%)";
    }
  }, [context, darkMode, isStorybook]);

  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
}
